/**
 * Partner referral capture.
 *
 * A partner sends traffic with ?ref=<code>. The code is remembered for the rest
 * of the visit and written onto the cart, so an order placed later still credits
 * the partner who sent the buyer, even though the code was only ever in the URL
 * of the first page they landed on.
 *
 * Storage can throw outright in a private window or with site data blocked, so
 * every access is guarded and a failure degrades to "this visit only" rather
 * than breaking the page.
 */
(function () {
  var KEY = 'partnerRef';

  function read(key) {
    try { return localStorage.getItem(key); } catch (error) { return null; }
  }

  function write(key, value) {
    try { localStorage.setItem(key, value); } catch (error) { /* private mode */ }
  }

  var fromUrl = new URLSearchParams(window.location.search).get('ref');
  if (fromUrl) write(KEY, fromUrl);

  var ref = fromUrl || read(KEY);
  if (!ref) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { Partner: ref } }),
  }).catch(function () {
    // A cart that cannot be updated must not take the page down with it.
  });
})();
